module.exports = __webpack_public_path__ + "static/media/LegoFloatingHQEXTA0011_design_clean_v001.566a71ee.png";